var map = {
	"./data-tw.json": [
		"811e",
		"chunk-2d0dd403"
	],
	"./data-zh.json": [
		"91c2",
		"chunk-2d0e4e3d"
	],
	"./data.json": [
		"77ed",
		"chunk-2d0d7c75"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "d286";
module.exports = webpackAsyncContext;